import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"
import isValidFpcBoardThickness from "../../../../service/visibleValidator/isValidFpcBoardThickness"

import img from "./boardThickness_FPC.png"

const ベース材厚 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { fpcBoardThickness: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField isShow={shouldShow} legend="ベース材厚" helpURL={HELP_LINKS.ベース材厚} src={img}>
      <RadioGroup
        name={FIELD_NAMES.ベース材厚}
        selectedValue={values.fpcBoardThickness}
        onChange={handlers.radio}
        shouldRender={(value) => isValidFpcBoardThickness(values, value)}
      >
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT.ベース材厚["12.5μm(0.1mm未満)"].value}>12.5μm</Radio>
          <Radio value={ESTIMATE_CONSTANT.ベース材厚["12.5μm(0.1mm以上__片面)"].value}>12.5μm</Radio>
          <Radio value={ESTIMATE_CONSTANT.ベース材厚["12.5μm(0.1mm以上__2層)"].value}>12.5μm</Radio>
          <Radio value={ESTIMATE_CONSTANT.ベース材厚["12.5μm(3層)"].value}>12.5μm</Radio>
          <Radio value={ESTIMATE_CONSTANT.ベース材厚["12.5μm(4層)"].value}>12.5μm</Radio>

          <Radio value={ESTIMATE_CONSTANT.ベース材厚["25μm(0.1mm未満)"].value}>25μm</Radio>
          <Radio value={ESTIMATE_CONSTANT.ベース材厚["25μm(0.1mm以上__片面)"].value}>25μm</Radio>
          <Radio value={ESTIMATE_CONSTANT.ベース材厚["25μm(0.1mm以上__2層)"].value}>25μm</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.fpcBoardThickness} />
    </OneClickField>
  )
}

export default ベース材厚
